/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

import { Heading, DisplayHtmlContent } from 'sarsaparilla';

export default function PermitLotteryDescription({ description = '' }) {
    return (
        <div className="lottery-description">
            <Heading appearance="h5" headingLevel={2}>
                Lottery Information
            </Heading>
            <div id="lotteryDescription">
                <DisplayHtmlContent html={description} />
            </div>
        </div>
    );
}

PermitLotteryDescription.propTypes = {
    description: PropTypes.string,
};
